import React, { useContext, useEffect, useState } from "react";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "./Templates.css";
import MenuTop from "../../components/MenuTop/MenuTop";

import TemplateEditor from "../../components/TemplateEditor/TemplateEditor";
import TableComponent from "../../components/TableComponent/TableComponent";
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import useTemplates from "../../context/hooks/useTemplates";
import DescriptionIcon from "@mui/icons-material/Description";
import { Button } from "reactstrap";
import TableComponentOther from "../../components/TableComponentOther/TableComponentOther";
import ModalConfirm from "../../components/ModalConfirm/ModalConfirm";
import TemplateReplacer from "../../components/TemplateReplacer/TemplateReplacer";

const Templates = () => {
  const {
    tableTemplates,
    totalTemplates,
    getTemplatesByUserId,
    getTemplates,
    deleteTemplates,
  } = useTemplates();

  const [template, setTemplate] = useState("");
  const [nameTemplate, setNameTemplate] = useState("");

  const [openModalDelete, setOpenModalDelete] = useState({
    open: false,
    idDelete: "",
  });
  const [openAddTemplate, setOpenAddTemplate] = useState({
    open: false,
    id: "",
  });
  const [openUseTemplate, setOpenUseTemplate] = useState({
    open: false,
    id: "",
  });

  const headCells: readonly any[] = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: "Nome do Template",
      disableSort: true,
    },
    {
      id: "data",
      numeric: false,
      disablePadding: true,
      label: "Data Criação",
      disableSort: true,
    },
    {
      id: "",
      numeric: false,
      disablePadding: false,
      disableSort: true,
      label: "",
    },
  ];

  const handleEdit = async (id: any) => {
    const template = await getTemplates(id);

    if (template) {
      setTemplate(template.template);
      setNameTemplate(template.nameTemplate);
      setOpenAddTemplate({ open: true, id: template.id });
    }
  };

  const applyTemplate = async (id: any) => {
    const template = await getTemplates(id);

    if (template) {
      setTemplate(template.template);
      setNameTemplate(template.nameTemplate);
      setOpenUseTemplate({ open: true, id: template.id });
    }
  };

  const removeItem = async () => {
    await deleteTemplates(openModalDelete.idDelete);
    setOpenModalDelete({ open: false, idDelete: "" });
    getTemplatesByUserId(1);
  };

  useEffect(() => {
    const getData = async () => {
      await getTemplatesByUserId(1);
    };
    getData();
  }, []);

  return (
    <>
      <LoadingSpinner />

      <MenuTop />

      <div
        className="mt-3 ml-3 mr-2 pt-4 pb-4 pl-4 d-flex"
        style={{
          height: "100%",
          backgroundColor: "#fff",
          gap: "20px",
          flexDirection: "column",
          borderRadius: "5px",
        }}
      >
        <div
          className="d-flex justify-content-between"
          style={{ alignItems: "center", gap: "17px" }}
        >
          <span className="title-page-document">MEUS TEMPLATES</span>
          <div className="mr-4">
            {(openAddTemplate.open || openUseTemplate.open) && (
              <Button
                className="secondary"
                onClick={() => {
                  setOpenAddTemplate({ open: false, id: "" });
                  setOpenUseTemplate({ open: false, id: "" });
                  getTemplatesByUserId(1);
                  setTemplate("");
                  setNameTemplate("");
                }}
                block
              >
                Voltar
              </Button>
            )}
            {!openAddTemplate.open && !openUseTemplate.open && (
              <Button
                className="button-login"
                onClick={() => setOpenAddTemplate({ open: true, id: "" })}
                block
              >
                Criar Novo Template
              </Button>
            )}
          </div>
        </div>

        {openAddTemplate.open && (
          <TemplateEditor
            value={template}
            onChange={setTemplate}
            nameTemplate={nameTemplate}
            setNameTemplate={setNameTemplate}
            openAddTemplate={openAddTemplate}
          />
        )}

        {openUseTemplate.open && (
          <TemplateReplacer
            template={template}
            nameTemplate={nameTemplate}
            openUseTemplate={openUseTemplate}
          />
        )}

        {!openAddTemplate.open &&
          !openUseTemplate.open &&
          tableTemplates?.length > 0 && (
            <>
              <div
                key={
                  tableTemplates?.map((item: any) => item.id).join("-") +
                  openAddTemplate
                }
              >
                <TableComponentOther
                  showId={false}
                  page={0}
                  rowsPerPage={10}
                  headCells={headCells}
                  rows={tableTemplates}
                  editItem={(id: any) => handleEdit(id)}
                  applyTemplate={(id: any) => applyTemplate(id)}
                  removeItem={(id: any) =>
                    setOpenModalDelete({
                      open: true,
                      idDelete: id,
                    })
                  }
                />
              </div>
              <div className="d-flex justify-content-end pb-2 pr-2">
                <PaginationMaterial
                  onChange={(e: any, page: number) =>
                    getTemplatesByUserId(page || 0)
                  }
                  count={totalTemplates}
                />
              </div>
            </>
          )}
        {!openAddTemplate.open &&
          !openUseTemplate.open &&
          tableTemplates?.length === 0 && (
            <TableComponent headCells={headCells} rows={[]} />
          )}

        <hr className="my-2" style={{ color: "#DDD", width: "100%" }} />
      </div>

      <ModalConfirm
        openModal={openModalDelete.open}
        closeModal={() => setOpenModalDelete({ open: false, idDelete: "" })}
        handleConfirm={removeItem}
      />
    </>
  );
};

export default Templates;
